import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {GeneralLabelUrlModel} from '@models/@base/general-label-url.model';
import {LocalStorageService} from '@services/local-storage.service';
import {environment} from 'environments/environment';

@Component({
    selector: 'error-dialog',
    templateUrl: 'error-dialog.component.html',
    styleUrls: ['error-dialog.scss']
})
export class ErrorDialogComponent {

    guardRedirectUrls: GeneralLabelUrlModel[] = [];

    constructor(
        private dialogRef: MatDialogRef<ErrorDialogComponent>,
        private localStorageService: LocalStorageService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {

        if (!environment.production) {
            console.table(data);
        }

        this.guardRedirectUrls = this.localStorageService.loadGuardRedirectUrl();

    }

    dialogClose() {
        this.dialogRef.close();
    }

    guardRedirectUrlsAvailable(): boolean {
        return (this.guardRedirectUrls.length > 0);
    }

    openGuardRedirectUrl(url: string): void {
        this.dialogRef.close(url);
    }
}
